import { Component, OnInit, Input, Output, EventEmitter, AfterContentInit } from '@angular/core';
import { MultipleOptionsInputBlockItemBase, ParagraphBlockItem, PatientInfoBlockItem, SignatureBlockItem, SimpleInputBlockItemBase } from '../../../../core/models/physician/form-doc-builder';
import { FormService } from '../../../../core/services/v2/form.service';
import { GetPatientDataOptionPipe } from '../../../../shared/pipes/get-patient-data-option.pipe';

@Component({
  selector: 'app-form-block-item',
  templateUrl: './form-block-item.component.html',
  styleUrls: ['./form-block-item.component.scss']
})
export class FormBlockItemComponent implements OnInit, AfterContentInit {
  @Input() blockItem: any;
  @Input() index: number;
  @Output() moveBlock = new EventEmitter();
  @Output() setItemId = new EventEmitter<number>();
  @Input() blockLength: number;
  @Input() blockId: number;

  contentTypeOptions: any[];
  isCollapsed = true;
  selectedOption: string;

  constructor(private _formService: FormService,
    private _patientDataOptionPipe: GetPatientDataOptionPipe) { }

  ngOnInit() {
    this.getContentTypes();
  }

  ngAfterContentInit() {
    if (!this.selectedOption)
      this.selectedOption = this.selectOption();
  }
  getContentTypes() {
    this.contentTypeOptions = this._formService.getContentTypeOptions();

  }
  moveBlockItem(direction: string) {
    this.moveBlock.emit({ index: this.index, action: direction });
  }
  selectOption(): string {
    switch (this.blockItem.type) {
      case 0:
        if (this.blockItem.html5InputType == 'date') {
          return 'InputDate';
        }
        else if (this.blockItem.html5InputType == 'number') {
          return 'InputNumber';
        }
        else {
          return 'InputText';
        }
      case 1:
        if (this.blockItem.selectionOption == 0) {
          return 'Decision';
        }
        else {
          return 'SelectOption';
        }
      case 2:
        return "Paragraph";
      case 3:
        return "InputData";
      case 5:
        return "Signature";
      default:
        return 'InputText';
    }
  }
  changeType() {
    //console.log('change', value);
    switch (this.selectedOption) {
      case "InputText":
        //this.blockItem = new SimpleInputBlockItemBase();
        this.blockItem = this.blockItem as SimpleInputBlockItemBase;
        this.blockItem.type = 0;
        this.blockItem.html5InputType = 'text';
        this.blockItem.label = !this.blockItem.label ? '' : this.blockItem.label;
        break;
      case "InputNumber":
        //this.blockItem = new SimpleInputBlockItemBase();
        this.blockItem = this.blockItem as SimpleInputBlockItemBase;
        this.blockItem.type = 0;
        this.blockItem.html5InputType = 'number';
        this.blockItem.label = !this.blockItem.label ? '' : this.blockItem.label;
        break;
      case "InputDate":
        //this.blockItem = new SimpleInputBlockItemBase();
        this.blockItem = this.blockItem as SimpleInputBlockItemBase;
        this.blockItem.type = 0;
        this.blockItem.html5InputType = 'date';
        this.blockItem.label = !this.blockItem.label ? '' : this.blockItem.label;
        break;
      case "Decision":
        //this.blockItem = new MultipleOptionsInputBlockItemBase();
        this.blockItem = this.blockItem as MultipleOptionsInputBlockItemBase;
        this.blockItem.type = 1;
        this.blockItem.selectionOption = 0;
        this.blockItem.question = !this.blockItem.question ? '' : this.blockItem.question;
        this.blockItem.options = !this.blockItem.options ? '' : this.blockItem.options;
        break;
      case "SelectOption":
        //this.blockItem = new MultipleOptionsInputBlockItemBase();
        this.blockItem = this.blockItem as MultipleOptionsInputBlockItemBase;
        this.blockItem.type = 1;
        this.blockItem.selectionOption = 2;
        this.blockItem.question = !this.blockItem.question ? '' : this.blockItem.question;
        this.blockItem.options = !this.blockItem.options ? '' : this.blockItem.options;
        break;
      case "Paragraph":
        //this.blockItem = new ParagraphBlockItem();
        this.blockItem = this.blockItem as ParagraphBlockItem;
        this.blockItem.type = 2;
        this.blockItem.text = !this.blockItem.text ? '' : this.blockItem.text;
        break;
      case "InputData":
        //this.blockItem = new PatientInfoBlockItem();
        this.blockItem = this.blockItem as PatientInfoBlockItem;
        this.blockItem.type = 3;
        break;
      case "Signature":
        //this.blockItem = new SignatureBlockItem();
        this.blockItem = this.blockItem as SignatureBlockItem;
        this.blockItem.type = 5;
        this.blockItem.role = !this.blockItem.role ? '' : this.blockItem.role;
        this.blockItem.withDate = !this.blockItem.withDate ? false : this.blockItem.withDate;
        break;

      default:
        break;

    }

    this.setItemId.emit(this.index);

    return true;
  }
  onChangeItem(value) {
    this.setItemId.emit(this.index);
  }
  selectedItemType(): string {
    return this.selectedOption && this.contentTypeOptions ? this.contentTypeOptions.find(c => c.id == this.selectedOption).text : 'New Input';
  }

  getPatientDataOption(value: any): string {

    var result;
    this._formService.getPatientInformationItemOptionsAll().subscribe((items) => {
      result = items ? items.filter((obj) => obj.patientInfo === value && obj.friendlyName) : result;
    },
      (error) => { console.error(error); });

    return result && result.length > 0 ? result[0].friendlyName : value;
  }
  getItemDescription(): string {
    return this.blockItem ? (this.blockItem.type == 3 ? '(User Data) ' + this._patientDataOptionPipe.transform(this.blockItem.patientInfo) :
      (this.blockItem.question ? '(' + this.selectedItemType() + ') ' + this.blockItem.question :
        (this.blockItem.label ? '(' + this.selectedItemType() + ') ' + this.blockItem.label :
          (this.blockItem.role ? '(' + this.selectedItemType() + ') ' + this.blockItem.role + 'Sign' :
            (this.blockItem.text ? this.blockItem.text : 'New Block Item'))))) : 'New Block Item';
  }
}
